<div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 px-[5%] py-[80px]">
  <div
    class="border border-gray-200 rounded-lg overflow-hidden"
    *ngFor="let item of news"
  >
    <img
      [src]="item.image ? 'https://admin.futuroacs.com.br/storage/' + item.image : 'https://api.dicebear.com/9.x/glass/svg?seed=Erick'"
      alt="{{ item.title }}"
      class="w-full h-40 object-cover"
    />
    <div class="p-4">
      <h6 class="text-base font-medium text-[#C1121F] mb-1">
        {{ item.title }}
      </h6>
      <p class="text-sm text-gray-600 mb-3 flex items-center">
        <i class="bx bx-calendar text-[#669BBC] mr-1"></i>
        {{ item.created_at | date: 'dd \'de\' MMMM \'de\' yyyy' : undefined : 'pt' }}
      </p>
      <button
        class="text-sm text-[#669BBC] font-medium hover:underline"
        (click)="openNews(item.id)"
      >
        Veja mais <i class="bx bx-right-arrow-alt align-middle"></i>
      </button>
    </div>
  </div>
</div>
